const BASE_PATH = (process.env.REACT_APP_BASE_PATH || "").replace(/\/$/, "");

export const getBasePath = (): string => BASE_PATH;

export const getAppPathname = (pathname?: string): string => {
	const raw = pathname ?? window.location.pathname;
	if (BASE_PATH && raw.startsWith(BASE_PATH)) {
		const stripped = raw.slice(BASE_PATH.length);
		return stripped.startsWith("/") ? stripped : "/" + stripped;
	}
	return raw;
};

export const prependBasePath = (path: string): string => {
	if (BASE_PATH && !path.startsWith(BASE_PATH)) {
		return BASE_PATH + (path.startsWith("/") ? path : "/" + path);
	}
	return path;
};
